export const VALIDATE_INTEGRATION_IN_PROGRESS = 'onboarding/validateIntegration';
export const VALIDATION_FINISHED = 'onboarding/validationFinished';
export const CLEAR_VALIDATION_RESULT = 'onboarding/cearValidationResult';
export const INTEGRATION_CONTENT_LOADING = 'onboarding/integrationContentLoading';
export const INTEGRATION_CONTENT_LOADED = 'onboarding/integrationContentLoaded';
export const STEP_CHANGED = 'onboarding/stepChanged';
